export const ButtonBaseDefaultProps = () => ({
  MuiButtonBase: {
    defaultProps: {
      // disableRipple: true,
      // disableTouchRipple: true,
    },
  },
});
